import { useQueryClient } from "@tanstack/react-query"

import {
  TTaskEventFetchFilters,
  TTaskFetchFilters,
} from "src/data/taskManagement/taskManagementTypes"

export const taskKeys = {
  all() {
    return ["tasks"] as const
  },

  taskLists() {
    return [...this.all(), "list"] as const
  },

  taskList(filters?: TTaskFetchFilters) {
    if (!filters) {
      return [...this.taskLists()] as const
    }

    return [...this.taskLists(), filters] as const
  },

  task(taskId: string) {
    return [...this.all(), taskId] as const
  },

  taskTypes() {
    return [...this.all(), "types"] as const
  },

  taskEvents({
    taskId,
    filters,
  }: {
    taskId: string
    filters?: TTaskEventFetchFilters
  }) {
    if (!filters) {
      return [...this.task(taskId), "events"] as const
    }

    return [...this.task(taskId), "events", filters] as const
  },
} as const

export function useTaskCache() {
  const queryClient = useQueryClient()

  function invalidateTaskList(filters?: TTaskFetchFilters) {
    const cacheKey = taskKeys.taskList(filters)

    return queryClient.invalidateQueries({
      queryKey: cacheKey,
    })
  }

  function invalidateTask(taskId: string) {
    return queryClient.invalidateQueries({
      queryKey: taskKeys.task(taskId),
    })
  }

  return {
    invalidateTaskList,
    invalidateTask,
  }
}
